import {
  BooleanInput,
  email,
  maxLength,
  minLength,
  useGetIdentity,
} from "react-admin";
import {
  DebouncedDateInput,
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
  useFieldLabel,
} from "ra-friendsofbabba";
import React, { useEffect, useMemo, useRef } from "react";
import { useForm, useFormState } from "react-final-form";

import { get } from "lodash";
import useFormPermission from "../useFormPermission";

const TroInput = (props) => {
  const didMount = useRef(false);
  const fieldLabel = useFieldLabel({ ...props });
  const hasFormPermission = useFormPermission(["admin", "region"]);
  const form = useForm();
  const formState = useFormState();
  const isTro = useMemo(
    () => get(formState.values, "is_tro", false),
    [formState.values]
  );
  const { identity, loaded } = useGetIdentity();
  useEffect(
    () => {
      if (!didMount.current && loaded) {
        didMount.current = true;
        return;
      }
      if (!isTro || !loaded) {
        return;
      }

      form.batch(() => {
        if (hasFormPermission("tro_name")) {
          form.change("tro_name", get(identity, "name"));
        }
        if (hasFormPermission("tro_surname")) {
          form.change("tro_surname", get(identity, "surname"));
        }
        if (hasFormPermission("tro_fiscal_code")) {
          form.change("tro_fiscal_code", get(identity, "fiscal_code"));
        }
        if (hasFormPermission("tro_email")) {
          form.change("tro_email", get(identity, "email"));
        }
        if (hasFormPermission("tro_perc")) {
          form.change("tro_pec", get(identity, "pec"));
        }
        if (hasFormPermission("tro_phone")) {
          form.change("tro_phone", get(identity, "phone"));
        }
        if (hasFormPermission("tro_birth_date")) {
          form.change("tro_birth_date", get(identity, "birth_date"));
        }
        if (hasFormPermission("tro_birth_place")) {
          form.change("tro_birth_place", get(identity, "birth_place"));
        }
        if (hasFormPermission("tro_birth_province")) {
          form.change("tro_birth_province", get(identity, "birth_province"));
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isTro, form, loaded]
  );
  return (
    <Group wrapper {...props}>
      <GroupTitle title={fieldLabel(props.source)} />

      <BooleanInput source="is_tro" helperText={fieldLabel("is_tro.help")} />

      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_name"
            maxLength={100}
            disabled={!hasFormPermission("tro_name")}
          />
        </GroupItem>

        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_surname"
            maxLength={100}
            disabled={!hasFormPermission("tro_surname")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedDateInput
            source="tro_birth_date"
            disabled={!hasFormPermission("tro_birth_date")}
          />
        </GroupItem>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_birth_place"
            maxLength={100}
            disabled={!hasFormPermission("tro_birth_place")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_birth_province"
            maxLength={2}
            disabled={!hasFormPermission("tro_birth_province")}
          />
        </GroupItem>

        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_fiscal_code"
            maxLength={16}
            validate={[minLength(16), maxLength(16)]}
            disabled={!hasFormPermission("tro_fiscal_code")}
          />
        </GroupItem>
      </Group>

      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_email"
            maxLength={250}
            type="email"
            validate={[email()]}
            disabled={!hasFormPermission("tro_email")}
          />
        </GroupItem>

        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_pec"
            maxLength={250}
            type="email"
            validate={email()}
            disabled={!hasFormPermission("tro_pec")}
          />
        </GroupItem>
      </Group>
      <Group>
        <GroupItem lg={4} md={4} sm={12}>
          <DebouncedTextInput
            source="tro_phone"
            maxLength={250}
            type="tel"
            disabled={!hasFormPermission("tro_phone")}
          />
        </GroupItem>
      </Group>
    </Group>
  );
};
export default TroInput;
